import angular from 'angular'
import routers from './routers'
import declareDetailRootCtrl from './declareDetailRootCtrl'
import { details } from 'redevConfig'

const list = (details && details.list) || ''
const declareDetailCtrl = list ? require(`redevelopment/outputManage/details/${list.controllerName}`) : require('./declareDetailCtrl')
export default angular
    .module('statistics.declareStatistics.declareDetail', [
    ]).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }]).controller('declareDetailRootCtrl', declareDetailRootCtrl)
    .controller('declareDetailCtrl', declareDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/details/index.js